import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme as newTheme } from 'styles/theme/hav-theme'

interface LabelWrapperProps {
  disabled?: boolean
}

export const TextFieldWrapper = styled.fieldset`
  padding: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .Mui-disabled {
    -webkit-text-fill-color: ${newTheme.colors.neutral.mediumhover} !important;
  }

  .MuiFormControl-root.MuiTextField-root {
    width: 100%;
  }
`

export const PickersDayWrapper = styled.div`
  .MuiPickersDay-root {
    color: ${newTheme.colors.neutral.black};
    background: transparent;
    font-weight: ${newTheme.typography.weight.lg};
    font-size: ${newTheme.typography.sizes.sm};
    line-height: 19.84px;
  }

  .MuiPickersDay-dayOutsideMonth {
    color: ${newTheme.colors.neutral.lighthover};
  }

  .Mui-selected {
    color: ${newTheme.colors.neutral.black} !important;
    background: ${newTheme.colors.neutral.clear} !important;
  }

  .Mui-disabled {
    color: ${newTheme.colors.neutral.lighthover} !important;
  }
`
export const LabelWrapper = styled.div<LabelWrapperProps>`
  display: flex;
  height: 17px;
  align-items: center;
  gap: ${newTheme.spacing.ion.xsmall3};

  label {
    font-size: ${newTheme.typography.sizes['2xs']};
    font-family: ${newTheme.typography.family.primary};
    font-weight: ${newTheme.typography.weight.lg};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      label {
        color: ${newTheme.colors.neutral.medium} !important;
      }
    `}
`
